import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { useImpressionRef, useTrackableLink } from '@noths/polaris-client-react-hooks';
import { appStoreURL, googlePlayURL, IconAppStore, IconGooglePlay, OutlineButtonLink } from '@noths/polaris-client-ribbons-design-system';
import * as styles from "./FooterAppPromo.styles";
import { FooterPromo } from "../FooterPromo/FooterPromo";
var appPromoImpression = function appPromoImpression(appStore) {
  sendGAEvent({
    event: 'custom_event',
    event_action: 'App download impression',
    event_category: 'Footer',
    event_label: appStore
  });
};
var aboutAppsUrl = 'https://www.notonthehighstreet.com/about/apps';
var getTrackingEvent = function getTrackingEvent(label, destinationUrl) {
  return {
    event: 'custom_event',
    event_action: 'App download click',
    event_category: 'Footer',
    event_label: label,
    destination_URL: destinationUrl
  };
};
export var FooterAppPromo = function FooterAppPromo() {
  var appPromoDesktop = useImpressionRef(function () {
    return appPromoImpression('find out more');
  });
  var appPromoApple = useImpressionRef(function () {
    return appPromoImpression('apple');
  });
  var appPromoAndroid = useImpressionRef(function () {
    return appPromoImpression('android');
  });
  var aboutAppsTrackingEvent = getTrackingEvent('find out more', aboutAppsUrl);
  var appStoreTrackingEvent = getTrackingEvent('apple', appStoreURL);
  var androidTrackingEvent = getTrackingEvent('android', googlePlayURL);
  var _useTrackableLink = useTrackableLink(),
    trackLinkClick = _useTrackableLink.trackLinkClick,
    trackLinkMouseDown = _useTrackableLink.trackLinkMouseDown;
  return /*#__PURE__*/React.createElement(FooterPromo, {
    intro: "Discover the easiest way to shop",
    title: "Get the app"
  }, /*#__PURE__*/React.createElement("div", {
    ref: appPromoDesktop
  }, /*#__PURE__*/React.createElement(_StyledOutlineButtonLink, {
    compact: true,
    href: aboutAppsUrl,
    onClick: function onClick(e) {
      trackLinkClick(aboutAppsTrackingEvent)(e);
    },
    title: "Noths app",
    $_css: styles.button
  }, "Learn more")), /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css2: styles.mobileButtons
  }, /*#__PURE__*/React.createElement("div", {
    ref: appPromoApple
  }, /*#__PURE__*/React.createElement(_StyledA, {
    href: appStoreURL,
    onClick: trackLinkClick(appStoreTrackingEvent),
    onMouseDown: trackLinkMouseDown(appStoreTrackingEvent),
    title: "App Store",
    $_css3: styles.link
  }, /*#__PURE__*/React.createElement(IconAppStore, {
    height: "40",
    width: "121"
  }))), /*#__PURE__*/React.createElement("div", {
    ref: appPromoAndroid
  }, /*#__PURE__*/React.createElement(_StyledA2, {
    href: googlePlayURL,
    onClick: trackLinkClick(androidTrackingEvent),
    onMouseDown: trackLinkMouseDown(androidTrackingEvent),
    title: "Google Play",
    $_css4: styles.link
  }, /*#__PURE__*/React.createElement(IconGooglePlay, {
    height: "40",
    width: "135"
  })))));
};
var _StyledOutlineButtonLink = _styled(OutlineButtonLink)(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledA = _styled3("a")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledA2 = /*#__PURE__*/_styled4("a").withConfig({
  displayName: "FooterAppPromo___StyledA2",
  componentId: "sc-jk68jr-0"
})(["", ""], function (p) {
  return p.$_css4;
});